<template>
  <div>
    <template v-if="routeHasLayout">
      <component :is="layout">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </component>
    </template>
  </div>
</template>

<script>
import store from '@app/store';

export default {
  data() {
    return {
      translationLoaded: false,
    };
  },
  mounted() {
    this.loadTenantsIfLoggedIn();
  },
  methods: {
    loadTenantsIfLoggedIn() {
      if (this.$authService.isLoggedIn()) {
        console.log('Getting tenants');
        const tenantId = this.$authService.getTenantId();
        this.$store.dispatch('tenant/getTenants', { selected_tenant_id: tenantId });
      }
    },
  },
  computed: {
    defaultLayout() {
      return 'bpc-admin'; // NOTE: not sure about what should be the default
    },
    layout() {
      return `${this.$route.meta.layout || this.defaultLayout}-layout`;
    },
    routeHasLayout() {
      return this.$route?.meta?.layout;
    },
  },
};
</script>
